import type { OfferSuggestion, PublicResource } from '../../shared/types.ts';

/**
 * 紹介枠。
 *
 * 有料サービスには必ず「広告」表記を付ける（景品表示法のステルスマーケティング
 * 規制により、広告であることが一般消費者に分かる表示が必要）。小さな注記では
 * なく、カード上の要素として設計している。
 * 無料の公的窓口は有料サービスより先に置く。
 */
export function Suggestions({
  offers = [],
  resources = [],
}: {
  offers?: OfferSuggestion[];
  resources?: PublicResource[];
}) {
  if (offers.length === 0 && resources.length === 0) return null;

  return (
    <div className="suggestions">
      {resources.length > 0 && (
        <>
          <p className="suggestions__label">無料で使える窓口</p>
          {resources.map((resource) => (
            <a
              key={resource.id}
              className="card card--free"
              href={resource.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="card__top">
                <span className="card__name">{resource.name}</span>
                <span className="tag tag--free">無料</span>
              </span>
              <p className="card__reason">{resource.oneLiner}</p>
            </a>
          ))}
        </>
      )}

      {offers.length > 0 && (
        <>
          <p className="suggestions__label">役に立ちそうなサービス</p>
          {offers.map((offer) => (
            <a
              key={offer.offerId}
              className="card"
              href={offer.href}
              target="_blank"
              rel="noopener noreferrer sponsored"
            >
              <span className="card__top">
                <span className="card__name">{offer.name}</span>
                <span className="card__provider">{offer.provider}</span>
                <span className="tag tag--ad">広告</span>
              </span>
              <p className="card__reason">{offer.reason || offer.oneLiner}</p>
              {offer.caution && <p className="card__caution">{offer.caution}</p>}
            </a>
          ))}
        </>
      )}
    </div>
  );
}
